import { render } from "./OperatorSelector.vue?vue&type=template&id=36efef2a&scoped=true"
import script from "./OperatorSelector.vue?vue&type=script&lang=ts"
export * from "./OperatorSelector.vue?vue&type=script&lang=ts"

import "./OperatorSelector.vue?vue&type=style&index=0&id=36efef2a&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-36efef2a"

export default script